export const preFillPickupFields = (
  data,
  address,
  pickup_address,
  timeframe,
) => {
  data["timeslot"] = timeframe;
  let groups;
  if (address != null || address !== undefined) {
    groups = address.split(", ");
  } else {
    groups = pickup_address.split(", ");
  }
  const [name, street, postCodeAndCity] = groups;
  const [postCode, city] = postCodeAndCity.split(" ");
  data["pickup_store_name"] = name;
  data["pickup_address"] = street;
  data["pickup_postcode"] = postCode;
  data["pickup_city"] = city;
  data["another_billing"] = "true";
  if (data["email_is_autogenerated"]) {
    data["email_is_autogenerated"] = false;
    data["email"] = "";
  }
  return data;
};

export const preFillDeliveryFields = (
  data,
  post_city,
  is_shipping,
  delivery_address,
  timeframe,
) => {
  data["timeslot"] = timeframe;
  if (!("delivery_address_id" in data) && delivery_address) {
    data["delivery_address_id"] = delivery_address.id;
    data["delivery_address_additional_info"] = delivery_address.additional_info;
    data["delivery_address_name"] = delivery_address.name;
    data["delivery_address_lastname"] = delivery_address.lastname;
    data["delivery_address_street"] = delivery_address.street;
    data["delivery_address_postcode_number"] = delivery_address.postcode.number;
    data["delivery_address_postcode_city"] = delivery_address.postcode.city;
  }
  if (data["different_invoice_address"]) {
    data["another_billing"] = "true";
  }
  if (data["email_is_autogenerated"]) {
    data["email_is_autogenerated"] = false;
    data["email"] = "";
  }
  return data;
};
